import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, AlertIcon, Box, Spinner, useToast } from "@chakra-ui/react";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import { getSignedLineAdvice } from "./services/PlacingAPI";
import { showApiErrorToast } from "./utils/showApiToast";
import CarrierSignedLineAdviceView from "./components/placing/CarrierSignedLineAdviceView";

/** A signed line advice sent to one of the carrier's parties. */
const PlacingSignedLineAdvicePage = () => {
  const { signedLineAdviceId } = useParams();
  const toast = useToast();
  const [advice, setAdvice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setAdvice(await getSignedLineAdvice(signedLineAdviceId));
      setError(null);
    } catch (err) {
      setError(err);
      showApiErrorToast(toast, err, { title: "Couldn't load signed line advice" });
    } finally {
      setLoading(false);
    }
  }, [signedLineAdviceId, toast]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box position="relative" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />
      <Box p={6} maxW="1400px" mx="auto">
        {loading ? (
          <Spinner />
        ) : error || !advice ? (
          <Alert status="error"><AlertIcon />{error?.message || "Signed line advice not found."}</Alert>
        ) : (
          <CarrierSignedLineAdviceView advice={advice} />
        )}
      </Box>
    </Box>
  );
};

export default PlacingSignedLineAdvicePage;
